import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PDFDialogComponent } from 'src/app/signup-organization/pdf-dialog/pdf-dialog.component';

@Component({
  selector: 'app-patient-privacy-policy',
  templateUrl: './patient-privacy-policy.component.html',
  styleUrls: ['./patient-privacy-policy.component.scss']
})
export class PatientPrivacyPolicyComponent implements OnInit {

  constructor(
        public dialog: MatDialog,
    
  ) { }

  ngOnInit() {
  }
  openPrivacyPolicyDialog() {
    let data = {
      title: 'Privacy Policies',
      filename: 'Privacy Policy v4 2025.pdf',
    }
  
  
    this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }
  openTermsOfUsesDialog() {
    let data = {
      title: 'Appy Health Terms of Use',
      filename: 'Appy Health Terms of Use January 2024 v.4.pdf',
    }
  
  
    this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }
  openMedicalDisclaimers() {
    let data = {
      title: 'Medical Information Disclaimers',
      filename: 'Medical Information Disclaimer.pdf',
    }
  
  
    this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }
  openCopyright() {
    let data = {
      title: 'Appy Health Copyright',
      filename: 'Appy Health Copyright Notification.pdf',
    }
  
  
    this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }
}
